import React from 'react';
import { Grid } from '@mui/material';
import { Allocate } from '../listTeams/components/teamAllocate.dumb';
import { Team } from '../../../state/reduxRepositories/teams/team.interfaces';

interface AddedTeamManagersProps {
  onAddTeamManager: (id: string) => void;
  onRemoveTeamManager: (
    mode: 'players' | 'manager' | boolean,
    id: string,
  ) => void;
  team: Team;
}

export const AddedTeamManagers = ({
  onRemoveTeamManager,
  onAddTeamManager,
  team,
}: AddedTeamManagersProps) => {
  return (
    <Grid>
      {team.teamManager?.map((teamManager) => {
        return (
          <Grid item key={teamManager?.id} sx={{ my: 1 }}>
            <Allocate
              mode="manager"
              type="list"
              isAllocated={
                team?.playerIds
                  ? team?.playerIds.includes(teamManager.id)
                  : false
              }
              onRemoveAllocate={onRemoveTeamManager}
              allocateById={teamManager?.id}
              onAllocate={onAddTeamManager}
              name={`${teamManager?.firstName} ${teamManager?.lastName}`}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
